import React, { createContext, useState, useEffect } from 'react';
import { Global, css } from '@emotion/react';
import Inter from '../fonts/Inter-Variable.ttf';
import InterItalic from '../fonts/Inter-Italic-Variable.ttf';
import { heightBreakpoints, forSize } from '../utils/sizeMixins';
import getPreferredTheme from '../utils/getPreferredTheme';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {

    const [theme, setTheme] = useState("dark");

    /*

    () => {
        if (typeof window === "object" || typeof window !== "undefined") {
            const storedTheme = localStorage.getItem('theme');
            const validOptions = ['light', 'dark'];
            return validOptions.includes(storedTheme) ? storedTheme : getPreferredTheme();
        } else {
            return "light";
        }
    }

    */

    // const [reducedMotion, setReducedMotion] = useState(() => {
    //     if (typeof window !== "undefined") {
    //         const storedValue = localStorage.getItem('reducedMotion');
    //         return storedValue === 'true';
    //     }
    //     return false;
    // });

    const [reducedMotion, setReducedMotion] = useState(false);


    const [dashboardFs, setDashboardFs] = useState(false);

    useEffect(() => {
        if (typeof window === "object" || typeof window !== "undefined") {
            localStorage.setItem('theme', theme);
        } else {
            return;
        }
    }, [theme]);

    useEffect(() => {
        if (typeof window === "object" || typeof window !== "undefined") {
            localStorage.setItem('reducedMotion', reducedMotion);
        } else {
            return;
        }
    }, [reducedMotion]);

    const changeTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    const toggleReducedMotion = () => {
        setReducedMotion((prevReducedMotion) => !prevReducedMotion);
    };

    const themeVariables = {
        light: {

            '--logo-text-color': '#83827d',

            '--body-background-color': '#F5F5F5',
            '--navbar-background-color': 'rgb(250 250 250 / 30%)',
            '--border-color': '#e0e0e0',
            '--content-background-color': 'rgb(250 250 250 / 30%)',
            '--main-stage-background-color': 'rgb(250 250 250 / 30%)',
            '--contact-btn-background-color': 'rgb(250 250 250 / 30%)',
            '--contact-btn-border': '#B2B2B2',
            '--ex-primary-text-color': '#17375E',
            '--nav-text-color': '#17375E',
            '--nav-highlighted': 'rgba(65, 106, 255, 0.08)',
            '--nav-highlighted-hover': '#c5d1fb',
            '--kpi-font-color': '#305684',
            '--kpi-bg-color': 'rgb(250 250 250 / 30%)',
            '--kpi-border-color': '#e0e0e0',
            '--kpi-selected-border-color': '#0061a4',
            '--illustration-line-color': '#3f3d56',
            '--special-text-start': '#17375E',
            '--special-text-end': '#DDE9F7',
            '--x-logo-color': '#000000',
            '--linkedin-color': '#0077b5',
            '--facebook-color': '#3b5998',
            '--youtube-color': '#ff0000'
        },
        dark: {

            '--logo-text-color': '#FFFFFF',

            '--body-background-color': '#0a163c',
            '--navbar-background-color': 'rgb(23 55 94 / 50%)',
            '--border-color': '#305684',
            '--content-background-color': 'rgba(48,86,132,0.5)',
            '--main-stage-background-color': 'rgba(23, 55, 94, 0.3)',
            '--contact-btn-background-color': '#305684',
            '--contact-btn-border': '#3d6eaa',
            '--ex-primary-text-color': '#DDE9F7',
            '--nav-text-color': '#DDE9F7',
            '--nav-highlighted': '#305684',
            '--nav-highlighted-hover': '#17375E',
            '--kpi-font-color': '#FFFFFF',
            '--kpi-bg-color': '#305684',
            '--kpi-border-color': '#3d6eaa',
            '--kpi-selected-border-color': '#007fd8',
            '--illustration-line-color': '#dae2ff',
            '--special-text-start': '#dae2ff',
            '--special-text-end': '#17375E',
            '--x-logo-color': '#e7e9ea',
            '--linkedin-color': '#e7e9ea',
            '--facebook-color': '#e7e9ea',
            '--youtube-color': '#e7e9ea'
        },
    };

    const cssVariables = Object.entries(themeVariables[theme])
        .map(([key, value]) => `${key}: ${value};`)
        .join('\n');

    const globalCss = css`
        @font-face {
            fony-family: 'Inter';
            src: url('${Inter}') format('truetype');
            font-weight: 100 900;
            font-style: normal;
        }
        @font-face {
            font-family: 'Inter Italic';
            src: url('${InterItalic}') format('truetype');
            font-weight: 100 900;
            font-style: italic;
        }

        :root {
            ${cssVariables}
        }

        body {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
            font-size: 16px;
            font-style: normal;
            background-color: var(--body-background-color);
            padding: 4vh 2vw;
            overflow: hidden;

            ${forSize(heightBreakpoints.small, 'down', 'y')} {
                padding: 1vh 2vw;
            }   
            ${'' /* transition: background-color 0.2s ease-in-out; */}
        }

        button {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        }
  `;

    return (
        <ThemeContext.Provider
            value={{
                theme,
                changeTheme,
                reducedMotion,
                toggleReducedMotion,
                dashboardFs,
                setDashboardFs
            }}
        >
            <Global styles={globalCss} />
            {children}
        </ThemeContext.Provider>
    );
};
